// src/ui/AmountInput.js
export class AmountInput {
  constructor({ langManager, currencyDropdown, onHTChange, onTTCChange }) {
    this._lm = langManager;
    this._dropdown = currencyDropdown;
    this._onHTChange = onHTChange;
    this._onTTCChange = onTTCChange;
    this._currency = 'USD';
    this._el = this._build();
  }

  get element() { return this._el; }

  _build() {
    const el = document.createElement('div');
    el.className = 'amount-inputs';

    // HT field
    const htGroup = document.createElement('div');
    htGroup.className = 'field-group';

    const htLabel = document.createElement('label');
    htLabel.className = 'field-label';
    htLabel.dataset.i18n = 'field.net';
    htLabel.textContent = this._lm.t('field.net');
    htLabel.setAttribute('for', 'input-ht');

    const htWrap = document.createElement('div');
    htWrap.className = 'input-wrap';

    const htPill = this._makePill();
    this._htPill = htPill;

    this._htInput = document.createElement('input');
    this._htInput.className = 'amount-input';
    this._htInput.type = 'number';
    this._htInput.min = '0';
    this._htInput.step = '0.01';
    this._htInput.placeholder = '0.00';
    this._htInput.id = 'input-ht';
    this._htInput.setAttribute('aria-label', this._lm.t('field.net'));
    this._htInput.addEventListener('input', () => {
      const val = parseFloat(this._htInput.value) || 0;
      this._onHTChange(val);
    });

    htWrap.appendChild(htPill);
    htWrap.appendChild(this._htInput);
    htGroup.appendChild(htLabel);
    htGroup.appendChild(htWrap);

    // Divider
    const divider = document.createElement('div');
    divider.className = 'divider-row';
    divider.innerHTML = `
      <div class="divider-line"></div>
      <i class="ti ti-arrows-up-down divider-icon" aria-hidden="true"></i>
      <div class="divider-line"></div>
    `;

    // TTC field
    const ttcGroup = document.createElement('div');
    ttcGroup.className = 'field-group';
    ttcGroup.style.marginTop = '8px';

    const ttcLabel = document.createElement('label');
    ttcLabel.className = 'field-label';
    ttcLabel.dataset.i18n = 'field.gross';
    ttcLabel.textContent = this._lm.t('field.gross');
    ttcLabel.setAttribute('for', 'input-ttc');

    const ttcWrap = document.createElement('div');
    ttcWrap.className = 'input-wrap';

    const ttcPill = this._makePill();
    this._ttcPill = ttcPill;

    this._ttcInput = document.createElement('input');
    this._ttcInput.className = 'amount-input';
    this._ttcInput.type = 'number';
    this._ttcInput.min = '0';
    this._ttcInput.step = '0.01';
    this._ttcInput.placeholder = '0.00';
    this._ttcInput.id = 'input-ttc';
    this._ttcInput.setAttribute('aria-label', this._lm.t('field.gross'));
    this._ttcInput.addEventListener('input', () => {
      const val = parseFloat(this._ttcInput.value) || 0;
      this._onTTCChange(val);
    });

    ttcWrap.appendChild(ttcPill);
    ttcWrap.appendChild(this._ttcInput);
    ttcGroup.appendChild(ttcLabel);
    ttcGroup.appendChild(ttcWrap);

    el.appendChild(htGroup);
    el.appendChild(divider);
    el.appendChild(ttcGroup);

    return el;
  }

  _makePill() {
    const pill = document.createElement('button');
    pill.className = 'currency-pill';
    pill.type = 'button';
    pill.setAttribute('aria-label', 'Select currency');
    pill.innerHTML = `<i class="ti ti-chevron-down" aria-hidden="true" style="font-size:11px;"></i> <span class="pill-text">USD</span>`;
    pill.addEventListener('click', (e) => {
      e.stopPropagation();
      this._dropdown.toggle(pill);
    });
    return pill;
  }

  setCurrency(code) {
    this._currency = code;
    this._htPill.querySelector('.pill-text').textContent = code;
    this._ttcPill.querySelector('.pill-text').textContent = code;
  }

  setHTValue(val) {
    this._htInput.value = val === 0 ? '' : val.toFixed(2);
  }

  setTTCValue(val) {
    this._ttcInput.value = val === 0 ? '' : val.toFixed(2);
  }

  updateTranslations() {
    this._el.querySelectorAll('[data-i18n]').forEach((el) => {
      el.textContent = this._lm.t(el.dataset.i18n);
    });
    this._htInput.setAttribute('aria-label', this._lm.t('field.net'));
    this._ttcInput.setAttribute('aria-label', this._lm.t('field.gross'));
  }
}
